// DESCRIPTION: Toggle buttons for switching between grid and list
// layout views in the events display.

import { __ } from '@wordpress/i18n';

const LayoutToggle = ( { layout, onLayoutChange } ) => {
	const activeClass = 'nb-bg-slate-600 nb-text-white nb-shadow-md';
	const inactiveClass =
		'nb-bg-white nb-text-slate-700 nb-border nb-border-slate-200 hover:nb-bg-slate-50 hover:nb-border-slate-300';
	const baseClass =
		'nb-p-2 nb-rounded-lg nb-transition-all nb-duration-200 nb-shadow-sm focus:nb-outline-none focus:nb-ring-2 focus:nb-ring-slate-500 focus:nb-ring-offset-2';

	return (
		<div className="nb-flex nb-gap-1">
			<button
				className={ `${ baseClass } ${
					layout === 'grid' ? activeClass : inactiveClass
				}` }
				onClick={ () => onLayoutChange( 'grid' ) }
				aria-label={ __( 'Grid view', 'nemtly-booking' ) }
				title={ __( 'Grid view', 'nemtly-booking' ) }
			>
				<svg
					className="nb-w-5 nb-h-5"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={ 2 }
						d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
					/>
				</svg>
			</button>
			<button
				className={ `${ baseClass } ${
					layout === 'list' ? activeClass : inactiveClass
				}` }
				onClick={ () => onLayoutChange( 'list' ) }
				aria-label={ __( 'List view', 'nemtly-booking' ) }
				title={ __( 'List view', 'nemtly-booking' ) }
			>
				<svg
					className="nb-w-5 nb-h-5"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={ 2 }
						d="M4 6h16M4 12h16M4 18h16"
					/>
				</svg>
			</button>
		</div>
	);
};

export default LayoutToggle;
